export default function getValueOfAQueryParameter (queryString, queryParameterName) {
    let arr = queryString.replace('?','').split('&');
    if(arr.length >0) {
        let filteredArr = arr.filter(a => a.indexOf(queryParameterName + '=')==0);
        if(filteredArr.length > 0){
            return filteredArr[0].replace(queryParameterName + '=','')
        }
    }
    return '';
    
}